let instance = null;

import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Modal from "../components/Modal";
import SmoothScroll from '../utils/SmoothScroll'
import Accordion from '../components/Accordion';
import NavAccordion from '../components/NavAccordion';
import Toggle from '../components/Toggle';
import ToggleFilter from '../components/ToggleFilter';
import VideoObserver from "../components/VideoObserver";
import HtmlVideoPlayer from '../components/HtmlVideoPlayer';
import Nav from '../components/Nav';
import PageObserver from '../components/PageObserver';
import BlockObserver from '../components/BlockObserver';
import TabsDropdown from "../components/Tabs";
import Dropdown from '../components/Dropdown';
import Dialogs from '../components/Dialogs';
import LocationTileHover from '../components/LocationTileHover';
import Cookies from '../components/CookiesConsent';
import LoadPost from '../components/LoadPosts'
import ImageParallax from '../components/ImageParallax';
import ItemParallax from '../components/ItemParallax';
import ListSlideshow from "../components/ListSlideshow";
import Slideshow from "../components/Slideshow";
import Carousel from "../components/Carousel";
import PageProgress from "../components/PageProgress";
import LoadCast from "../components/LoadCast";
import Placeholders from "../components/Placeholders";

export default class App {
	constructor() {


		// ============================================================================================
		// SETUP APP
		// ============================================================================================

		// Create singleton
		if (instance) {
			return instance;
		}
		instance = this;


		// Create global access
		window.app = this;


		// Get context
		this.getContext();
		window.addEventListener('resize', () => {
			this.getContext();
		});


		// ============================================================================================
		// GLOBAL FUNCTIONS
		// ============================================================================================

		this.pageObserver 	= new PageObserver()
		this.blockObserver 	= new BlockObserver(document.querySelectorAll('[data-watch="true"]'))
		this.modal 			= new Modal(document.querySelectorAll('[data-component="modal"]'))
		this.loadPosts 		= new LoadPost();
		this.imageParallax 	= new ImageParallax();
		this.itemParallax 	= new ItemParallax();
		this.nav 			= new Nav();
		this.navAccordion 	= new NavAccordion();
		this.placeholders 	= new Placeholders();

		// SETTING UP SMOOTH SCROLLING 
		this.smoothScroll = new SmoothScroll()

		// SETTING UP COOKIES
		this.cookies = new Cookies()


		// ============================================================================================
		// COMPONENTS
		// ============================================================================================


		this.parallaxItems = document.querySelectorAll('[data-speed]');
		this.parallaxItems && this.parallaxItems.forEach((parallaxItem)=>{
			new ItemParallax(parallaxItem);
		})

		this.listSlideshows = document.querySelectorAll('[data-component="list-slideshow"]');
		this.listSlideshows && this.listSlideshows.forEach((slideshow)=>{
			new ListSlideshow(slideshow);
		})

		this.accordions = document.querySelectorAll('[data-component="accordion"]');
		this.accordions && this.accordions.forEach((accordion) => {
			new Accordion(accordion).init();
		})

		this.carousel = document.querySelectorAll('[data-component="carousel"]');
		this.carousel && this.carousel.forEach((carousel)=>{
			new Carousel(carousel);
		})


		this.slideshow = document.querySelectorAll('[data-component="slideshow"]');
		this.slideshow && this.slideshow.forEach((slideshow)=>{
			new Slideshow(slideshow);
		})



		this.toggles = document.querySelectorAll('[data-component="toggle"]');
		this.toggles && this.toggles.forEach((toggle) => {
			new Toggle(toggle).init();
		})

		this.toggleFilters = document.querySelectorAll('[data-component="togglefilter"]');
		this.toggleFilters && this.toggleFilters.forEach((toggle) => {
			new ToggleFilter(toggle).init();
		})

		this.castLists = document.querySelectorAll('.block-cast');
		this.castLists && this.castLists.forEach((castList) => {
			new LoadCast(castList);
		})

		this.htmlVideos = document.querySelectorAll('.video--html');
		this.htmlVideos && this.htmlVideos.forEach((video)=>
		{

			let options =
			{
				autoplay: false,
				loop: true,
				muted: true,
				controls: true,
				cover: false,
			}

			if( video.classList.contains('video--autoplay') ){
				options.autoplay = true;
				options.controls = false;
			}

			if( video.classList.contains('video--cover') ){
				options.cover = true;
			}
			
			new HtmlVideoPlayer(video, options);

		})

		// this.tabs = document.querySelectorAll('[data-component="tabsdropdown"]');
		// this.tabs && this.tabs.forEach((tab)=>
		// {
		// 	new TabsDropdown(tab).init();
		// })


		this.dropdowns = document.querySelectorAll('[data-component="dropdown"]');
		this.dropdowns && this.dropdowns.forEach((dropdown)=>{
			new Dropdown(dropdown).init();
		})


		this.dialogs = document.querySelectorAll('[data-dialog]');
		this.dialogs && this.dialogs.forEach((dialog)=>{
			new Dialogs(dialog);
		})


		this.locationtiles = document.querySelectorAll('[data-component="location-tile"]');
		this.locationtiles && this.locationtiles.forEach((tile)=>{
			new LocationTileHover(tile);
		})


		this.pageProgress = document.querySelectorAll('[data-component="pageprogress"]');
		this.pageProgress && this.pageProgress.forEach((pageProgress)=>{
			new PageProgress(pageProgress);
		})

		let googleMap = document.getElementById('map');
		if(googleMap) {
			let map;
			let lat = googleMap.dataset.lat;
			let lng = googleMap.dataset.lng;
			async function initMap() {
				const { Map } = await google.maps.importLibrary("maps");
				const latLng = { lat: Number(lat), lng: Number(lng) };

				map = new Map(document.getElementById("map"), {
					center: latLng,
					zoom: 14,
				});

				new google.maps.Marker({
					position: latLng,
					map,
					title: "Hello World!",
				});
			}

			initMap();
		}

		// If landing on Venue Hire, scroll down to grid after page load
		// Requested to not use the hash/anchor tag method, preference is to load into the page and then smooth scroll down
		setTimeout(() => {
			if (document.getElementById('venues')) {
				const queryString = window.location.search;
				const urlParams = new URLSearchParams(queryString);
				if (urlParams.get('category') || urlParams.get('theatre')) {
					document.getElementById('venues').scrollIntoView({behavior: 'smooth'});
				}
			}
		}, 1000);
	}
	getContext() {
		// Tells us if App is Mobile

		if (window.matchMedia('(max-width: 1024px)').matches) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}

		if (window.matchMedia('(hover: none)').matches) {
			this.isTouch = true;
		} else {
			this.isTouch = false;
		}

		if (window.location.host.includes('localhost')) {
			this.URL =
				'http://' +
				window.location.host +
				`/${REPO}/wp-content/themes/${THEME}`;
		} else {
			this.URL =
				'https://' + window.location.host + `/wp-content/themes/${THEME}`;
		}

	}
}